/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description Button for manual EKYC
 */
import _ from 'lodash';
import { Button, App } from 'antd';

import { statusMapping } from './IdentityVerification';
import useUpdateIdentityVerificationStatus from 'hooks/admin/mutate/useUpdateIdentityVerificationStatus';
import AppEvents, { Events, Messages } from '@veritable/common/utils/appEvents';
import { isValidNpi } from 'utils/admin/npi';
import { useAppStoreValues } from 'store/app';
import { MODAL_TYPES } from '../modal';

/**
 * Mark Entity Verified
 *
 */
interface IProps {
	entity?: Provider.IResponseModel | Provider.IPaginatedResponseModel;
	onNext?: VoidFunction;
	style?: React.CSSProperties;
}

const VerifyNpiOffline: React.FC<IProps> = ({ entity, style = {}, onNext }) => {
	const { modal } = App.useApp();
	const { userAccess } = useAppStoreValues();
	const ekycStatus = entity?.ekycDetails?.verificationStatus;
	const ekycVerifiedList = [statusMapping.verified.code, statusMapping.verified_offline.code, statusMapping.verified_transitive.code];
	const shouldShowButton = userAccess.isInternalAdmin && !_.includes(ekycVerifiedList, ekycStatus) && !!isValidNpi(entity?.npi);

	// manual ekyc
	const { mutateAsync: updateIdVerificationStatus, isPending: isUpdatingStatus } = useUpdateIdentityVerificationStatus();
	const onVerified = () => {
		if (entity?.id) {
			modal.confirm({
				...MODAL_TYPES.confirm,
				content: 'Are you sure you want to mark this NPI status as verified?',
				onOk: () => updateIdVerificationStatus({ providerId: entity?.id }, { onSuccess: onNext }),
			});
		} else {
			AppEvents.publish(Events.Error, Messages.Error);
		}
	};

	if (!shouldShowButton) {
		return null;
	}

	return (
		<Button
			size='small'
			color='default'
			variant='outlined'
			loading={isUpdatingStatus}
			className='font-normal'
			style={{ fontSize: 18, ...style }}
			onClick={onVerified}
		>
			{'Mark as Verified'}
		</Button>
	);
};

export default VerifyNpiOffline;
